export class ErrorService{
    constructor() {

    }
    handleError(source: string, error: any) {
        console.log(source, error);
        return error;
    }
}


// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/_services/error.service.ts